import type { OverviewResponse } from "contracts/api/dashboard/responses";
import type { MapPageFact } from "./mapTypes";

/**
 * Selecting the facts a candidate change is about: which pages it covers, how
 * they group by role, and which of them the run's broken links and open issues
 * actually touch. Kept apart from the change factory so the selection rules
 * stay readable next to each other.
 */

export function factsForPages(
  facts: MapPageFact[],
  ids: string[],
): MapPageFact[] {
  const wanted = new Set(ids);
  return facts.filter((fact) => wanted.has(fact.page.id));
}

export function groupByRole(facts: MapPageFact[]): MapPageFact[][] {
  const groups = new Map<string, MapPageFact[]>();
  for (const fact of facts) {
    groups.set(fact.role, [...(groups.get(fact.role) ?? []), fact]);
  }
  return [...groups.values()];
}

export function brokenOutboundLinks(
  data: OverviewResponse,
  facts: MapPageFact[],
): number {
  const ids = new Set(facts.map((fact) => fact.page.id));
  return data.links.filter(
    (link) => ids.has(link.fromPageId) && link.agentBroken,
  ).length;
}

export function affectedFactsForIssues(
  data: OverviewResponse,
  facts: MapPageFact[],
  issueIds: string[],
): MapPageFact[] {
  const wantedIssues = new Set(issueIds);
  const brokenSources = new Set(
    data.links
      .filter((link) => link.agentBroken)
      .map((link) => link.fromPageId),
  );
  return facts.filter(
    (fact) =>
      brokenSources.has(fact.page.id) ||
      fact.issues.some((issue) => wantedIssues.has(issue.id)),
  );
}
